import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { PopoverModule } from '../../shared/popover/popover.module';
import { CardModule } from '../card-grid/components/card/card.module';
import { SupportModule } from '../support/support.module';
import { TrackElementDirective } from '../tracker/track-element.directive';
import { HeaderComponent } from './header.component';
import { HeaderQuickAccessModule } from './quick-access/quick-access.module';

@NgModule({
  declarations: [HeaderComponent],
  imports: [
    CommonModule,
    RouterModule,
    HeaderQuickAccessModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDividerModule,
    PopoverModule,
    SupportModule,
    CardModule,
    MatDialogModule,
    TranslocoModule,
    TrackElementDirective,
  ],
  exports: [HeaderComponent],
})
export class HeaderModule {}
